import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import SellerIcon from '../audittrails/SellerIcon';
import TerminalIcon from '../audittrails/TerminalIcon';
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import useApi from "../../components/Utils/api";
import { useEffect, useState } from "react";
import { DateRangePicker } from "rsuite";
import 'rsuite/dist/rsuite.min.css';
import { DateRange } from "@mui/icons-material";
import { useMaterialUIController, setDashboardDataPs, setDefaultCalendar } from "../../context";
import subDays from "date-fns/subDays";
import startOfMonth from "date-fns/startOfMonth";
import addMonths from "date-fns/addMonths";
import endOfMonth from "date-fns/endOfMonth";
import { PointOfSaleSharp } from "@mui/icons-material";
import toast from "react-hot-toast";
import {FormControl, InputLabel, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";


function Dashboard() {
  const { predefinedRanges } = reportsLineChartData;
  const [controller, dispatch] = useMaterialUIController();
  const {dashboardDataPs, defaultCalendarValue } = controller;
  const [dashboardData, setDashboardData] = useState(null);
  const { afterToday } = DateRangePicker;
  const api = useApi();

  const convertTransactionToReport = (originalData) => {
    const labels = [];
    const amounts = [];
    const counts = [];

    if (!originalData) {
      return {
        amountTable: {
          labels: [],
          datasets: [{
            label: "Amount",
            data: [],
            borderColor: "#FF6384",
            backgroundColor: "#FF6384",
            yAxisID: 'y',
          }]
        },
        countTable: {
          labels: [],
          datasets: [{
            label: "Count",
            data: [],
            borderColor: "#fff",
            backgroundColor: "#fff",
            yAxisID: 'y1',
          }]
        }
      };
    }

    originalData.forEach((item) => {
      labels.push(item.monthStr);
      amounts.push(item.amount);
      counts.push(item.count);
    });

    return {
      amountTable: {
        labels: labels,
        datasets: [{
          label: "Amount",
          data: amounts,
          borderColor: "#FF6384",
          backgroundColor: "#FF6384",
          yAxisID: 'y',
        }]
      },
      countTable: {
        labels: labels,
        datasets: [{
          label: "Count",
          data: counts,
          borderColor: "#fff",
          backgroundColor: "#fff",
          yAxisID: 'y1',
        }]
      }
    };
  }
  const formatDate = (date) => {
    const isoDate = new Date(date).toISOString();
    return isoDate.slice(0, 10); // Extracts only the date part
  };
  const getDashboardData = (lastMonthDateRange) => {
    if(lastMonthDateRange == null) return;
    setDefaultCalendar(dispatch, lastMonthDateRange);

    const data = {
      dateRangeIdentifier : "custom_range",
      fromDate : formatDate(lastMonthDateRange[0]),
      toDate : formatDate(lastMonthDateRange[1])
    }
    api.post("dashboard/admin", data)
      .then((response) => {
        setDashboardData(response.data);
        setDashboardDataPs(dispatch, response.data);
      })
  }

  useEffect(() => {
    if(Object.keys(dashboardDataPs).length === 0){
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfMonth = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);


      const currentMonthDateRange = [
        startOfMonth.toISOString().slice(0, 10),
        endOfMonth.toISOString().slice(0, 10),
      ];
      getDashboardData(currentMonthDateRange);
    } else {
      setDashboardData(dashboardDataPs);
    }
  },[])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon={<TerminalIcon />} 
                title="Total Active Terminals"
                count={dashboardData ? dashboardData.activeTerminalCount : 0}
                // percentage={{
                //   color: "success",
                //   amount: "+56%",
                //   label: "than lask week",
                // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon={<SellerIcon />}
                title="Total Active Merchants"
                count={dashboardData ? dashboardData.activeMerchantCount : 0}
                // percentage={{
                //   color: "success",
                //   amount: "+1%",
                //   label: "than yesterday",
                // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                  color="success"
                  icon="attach_money"
                  title="Total Transaction Value ($)"
                  count={dashboardData ? dashboardData.totalTransactionValue : 0}
                  // percentage={{
                  //   color: "success",
                  //   amount: "+1%",
                  //   label: "than yesterday",
                  // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                  color="success"
                  icon="poll"
                  title="Total Transaction Count"
                  count={dashboardData ? dashboardData.totalTransactionCount : 0}
                  // percentage={{
                  //   color: "success",
                  //   amount: "+1%",
                  //   label: "than yesterday",
                  // }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3} textAlign={"center"}>
                <DateRangePicker ranges={predefinedRanges} onChange={(date) => getDashboardData(date)} format="yyyy-MM-dd" value={Object.keys(defaultCalendarValue).length !== 0 ? [new Date(defaultCalendarValue[0]), new Date(defaultCalendarValue[1])] : []} />
              </MDBox>
            </Grid>
            {/*<Grid item xs={12} md={6} lg={4}>*/}
            {/*  <MDBox mb={3}>*/}
            {/*    <ReportsBarChart*/}
            {/*      color="info"*/}
            {/*      title="website views"*/}
            {/*      description="Last Campaign Performance"*/}
            {/*      date="campaign sent 2 days ago"*/}
            {/*      chart={reportsBarChartData}*/}
            {/*    />*/}
            {/*  </MDBox>*/}
            {/*</Grid>*/}
            {dashboardData ?
              <>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox mb={3}>
                    <ReportsLineChart
                        color="info"
                        title="Transactions Volume"
                        description={
                          <>
                          </>
                        }
                        date="updated just now"
                        chart={!dashboardData ? [] : convertTransactionToReport(dashboardData.transactions).countTable}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox mb={3}>
                    <ReportsLineChart
                      color="dark"
                      title="Transactions Value"
                      description={
                        <>
                        </>
                      }
                      date="updated just now"
                      chart={!dashboardData ? [] : convertTransactionToReport(dashboardData.transactions).amountTable}
                    />
                  </MDBox>
                </Grid>
              </>
              : <></>}
            {/*<Grid item xs={12} md={6} lg={4}>*/}
            {/*  <MDBox mb={3}>*/}
            {/*    <ReportsLineChart*/}
            {/*      color="dark"*/}
            {/*      title="completed tasks"*/}
            {/*      description="Last Campaign Performance"*/}
            {/*      date="just updated"*/}
            {/*      chart={tasks}*/}
            {/*    />*/}
            {/*  </MDBox>*/}
            {/*</Grid>*/}
          </Grid>
        </MDBox>
        {/*<MDBox>*/}
        {/*  <Grid container spacing={3}>*/}
        {/*    <Grid item xs={12} md={6} lg={8}>*/}
        {/*      <Projects />*/}
        {/*    </Grid>*/}
        {/*    <Grid item xs={12} md={6} lg={4}>*/}
        {/*      <OrdersOverview />*/}
        {/*    </Grid>*/}
        {/*  </Grid>*/}
        {/*</MDBox>*/}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
